import { FormsApi } from "../../common";
import { Client, User } from "../../common/interfaces";

export class ApplicationState {

    private formsApi: FormsApi;

    constructor(formsApi: FormsApi) {
        this.formsApi = formsApi;
    }

    private clients: Client[] | undefined = undefined;
    public selectedClientId: string | undefined = undefined;
    public currentUser: User | undefined = undefined;

    async getClients(): Promise<Client[]> {
        let clients = this.clients;
        if (clients == null)
            clients = await this.formsApi.get<Client[]>('Clients');

        return clients;
    }
}